import React, { Component } from 'react';
import ContentWrapper from '../../../components/Layout/ContentWrapper';

class FinalBalanceCellFormatter extends Component {
  render() {
    const { dependentValues: { PreviousBalance, Amount, DiscountedAmount } } = this.props;
    const discountedAmount = DiscountedAmount || 0;
    return (
      <ContentWrapper>
        {
          React.cloneElement(this.props.children, {
            value: PreviousBalance - Amount - discountedAmount,
          })
        }
      </ContentWrapper>
    );
  }
}

export default FinalBalanceCellFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/EditAR/finalBalanceCellFormatter.jsx